import React from 'react';
import { Section } from '../ui/Section';
import { AlertCircle } from 'lucide-react';
export function PainPoints() {
  const pains = [{
    title: 'Pacientes que se pierden del seguimiento',
    desc: 'Te enterás meses después que dejaron de venir a control.'
  }, {
    title: 'Trámites de autorización sin sistema',
    desc: 'Medicación de alto costo demorada y vos peleando por teléfono.'
  }, {
    title: 'Informes armados de cero cada vez',
    desc: 'Cada junta médica te lleva horas de búsqueda de papeles.'
  }, {
    title: 'Facturación desordenada',
    desc: 'No sabés con certeza cuánto te debe cada prestador.'
  }, {
    title: 'Todo en la cabeza, nada en sistema',
    desc: 'Si falta tu secretaria un día, se frena todo.'
  }, {
    title: 'Sin indicadores de tu propio consultorio',
    desc: 'No sabés si tu negocio está mejorando o estancado.'
  }, {
    title: 'Burnout que no detectás a tiempo',
    desc: 'Te das cuenta cuando ya estás agotado, no antes.'
  }, {
    title: 'Fin de mes sin visibilidad financiera',
    desc: 'Facturás, pero no sabés si rinde.'
  }];
  return <Section className="bg-white" data-id="element-190">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-191">
        <div className="text-center mb-8 md:mb-16" data-id="element-192">
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-3 md:mb-4" data-id="element-193">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-lg md:text-xl text-slate-600" data-id="element-194">
            Si tenés consultorio oncológico propio en Argentina, esto te suena
            familiar:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 md:gap-6" data-id="element-195">
          {pains.map((pain, i) => <div key={i} className="flex gap-3 md:gap-4 p-4 md:p-5 rounded-2xl bg-red-50 border border-red-100 hover:bg-red-100/50 transition-colors" data-id="element-196">
              <div className="flex-shrink-0 mt-0.5 md:mt-1" data-id="element-197">
                <AlertCircle className="h-5 w-5 md:h-6 md:w-6 text-red-500" data-id="element-198" />
              </div>
              <div data-id="element-199">
                <h3 className="font-bold text-slate-900 text-sm md:text-base mb-1" data-id="element-200">
                  {pain.title}
                </h3>
                <p className="text-slate-600 text-xs md:text-sm" data-id="element-201">{pain.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-10 md:mt-16 text-center" data-id="element-202">
          <h3 className="text-xl md:text-2xl font-bold text-slate-900" data-id="element-203">
            ¿Cuántos meses más vas a gestionar tu consultorio así?
          </h3>
        </div>
      </div>
    </Section>;
}